var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassenger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Icon__StyledIcon-sc-1det6wr-0 fhAORE",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.746 15.68C20.27 16.22 22 16.837 22 19.318V20a.4.4 0 01-.4.4h-3.01a.2.2 0 01-.199-.226c.008-.057.012-.116.012-.174v-1.2c0-3.682-2.533-4.875-4.48-5.595a.2.2 0 01-.113-.107 4.08 4.08 0 01-.207-.59.202.202 0 01.035-.174 6.952 6.952 0 001.352-4.279.2.2 0 01.118-.177A3.172 3.172 0 0116.4 7.6a2.929 2.929 0 013.003 3.184 4.494 4.494 0 01-1.172 3.45 2.052 2.052 0 00-.046 1.04.471.471 0 00.11.246l.45.16zM17.2 18.8V20a.4.4 0 01-.403.4h-13.6a.4.4 0 01-.4-.4v-1.196c0-3.168 2.211-3.95 4.16-4.64.204-.072.408-.145.61-.22.053-.022.132-.115.193-.32a2.669 2.669 0 00-.067-1.565c-.755-.83-1.497-1.863-1.497-4.423A3.713 3.713 0 0110 3.6a3.713 3.713 0 013.804 4.034c0 2.562-.742 3.592-1.5 4.428a2.686 2.686 0 00-.066 1.56c.061.207.14.3.194.32l.591.213c1.959.697 4.177 1.487 4.177 4.645z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassenger);
export default __webpack_public_path__ + "static/media/passenger.a0733db51f310d5856f4503e97cb7af4.svg";
export { ForwardRef as ReactComponent };